import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/core/state/appState';
import { selectRolesAsDropdownItems } from 'src/app/core/state/role/role.selectors';
import { RoleType, UserType } from 'src/app/core/state/types';

interface RoleOption {
  id: string;
  label: string;
}

export interface AuthRoleSelectorEvent {
  value: RoleType;
  originalUser: UserType;
  cancel: () => void;
}

@Component({
  selector: 'app-auth-role-selector',
  template: `
    <p-dropdown
      [options]="roleOptions$ | async"
      optionValue="id"
      [ngModel]="selectedRole"
      (ngModelChange)="onChangeRole($event)"
      appendTo="body"
      [autoOptionFocus]="false"
      [autoDisplayFirst]="false">
    </p-dropdown>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthRoleSelectorsComponent {
  @Input()
  set user(value: UserType) {
    this.originalRole = value?.role;
    this.selectedRole = value?.role;
    this.originalUser = value;
  }

  @Output() roleChange: EventEmitter<AuthRoleSelectorEvent | null>;

  public roleOptions$: Observable<RoleOption[]>;
  public selectedRole: RoleType;
  private originalRole: RoleType;
  private originalUser: UserType;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    store: Store<AppState>,
  ) {
    this.roleChange = new EventEmitter();
    this.roleOptions$ = store.select(selectRolesAsDropdownItems);
  }

  onChangeRole(newRole: RoleType) {
    if (newRole === this.selectedRole) {
      return;
    }
    const cancel = () => {
      // Forced delay to run as next microtask after Prime dropdown has rendered the first selected value
      setTimeout(() => {
        this.selectedRole = this.originalRole;
        this.changeDetectorRef.markForCheck();
      }, 0);
    };
    this.roleChange.emit({ cancel, value: newRole, originalUser: this.originalUser });
  }
}
